import {
    ProductType,
    Site,
    SuperbetRouteConfig,
} from '@superbet-group/web.types';
import VueRouter, { Route } from 'vue-router';

import OfferEvent from '@core/models/offer/OfferEvent';
import { currentSite } from '../utils/domainHelpers';
import { RouteName } from './constants/RouteName';

export function addRoutes(router: VueRouter, routes: SuperbetRouteConfig[]) {
    const presentRoutes = router.getRoutes().map(({ name }) => name).filter(Boolean);
    const presentRoutesSet = new Set(presentRoutes);
    routes.forEach((route) => {
        if (!presentRoutesSet.has(route.name)) {
            router.addRoute(route);
        }
    });
}

export function extractMatchName(route: Route, eventsMap: Record<string, OfferEvent> | undefined): string | null {
    const eventId = getEventIdFromRoute(route);
    if (!eventId) {
        return null;
    }

    return eventsMap?.[eventId] ? eventsMap[eventId].fullName : null;
}

export function redirectRoutesOnNapoleonHub(routeConfig: SuperbetRouteConfig): SuperbetRouteConfig {
    if (currentSite === Site.NapoleonGames) {
        if (routeConfig.name === RouteName.GrowthMarketing.LandingIntro
            || routeConfig.name === RouteName.App.Wiki
        ) {
            return routeConfig;
        } else {
            return {
                ...routeConfig,
                redirect: { name: RouteName.GrowthMarketing.LandingIntro },
            };
        }
    }
    return routeConfig;
}

export function getEnabledRoutes(productConfig: Record<ProductType, boolean>, routeConfigs: SuperbetRouteConfig[]): SuperbetRouteConfig[] {
    return routeConfigs
        .map(redirectRoutesOnNapoleonHub)
        .filter(({ isAccessible, meta }) => {
            const productType = meta?.productType;
            if (productType) {
                // Backwards compatibility with the old way with the product type, not to couple
                // federations and the shell. Use productConfig for the federation routes.
                return productConfig[productType];
            } else {
                return isAccessible === undefined || isAccessible;
            }
        });
}

function getEventIdFromRoute(route: Route): string | null {
    if (route.query?.e) {
        return route.query.e.toString();
    }
    if (!route.path) {
        return null;
    }

    const startOfId = route.path.lastIndexOf('-');
    if (startOfId < route.path.length) {
        return route.path.slice(startOfId + 1);
    }

    return null;
}
